<script setup lang="ts">
import { ref,reactive,onMounted,computed,onBeforeUnmount,toRefs,watch } from 'vue'
import ModalDialog from "../../compositions/ModalDialog.vue";
import SelectBox from "../../compositions/SelectBox.vue";
import TextBox from "../../compositions/TextBox.vue";
import CheckBox from "../../compositions/CheckBox.vue";
import PharmacyMedicineEditComponent from "./PharmacyMedicineEditComponent.vue";
import MedicineHistoryDetailComponent from "./MedicineHistoryDetailComponent.vue";
import MedicineHistoryListComponent from "./MedicineHistoryListComponent.vue";
import PrescriptAnalyzeListComponent from "./PrescriptAnalyzeListComponent.vue";
import PharmacyMedicineTagComponent from "./PharmacyMedicineTagComponent.vue";
import OrderPackComponent from "./OrderPackComponent.vue";
import config from "../../config.js";
import CustomEvent from "../../compositions/CustomEvent.vue";
import { errorAlert,confirmAlert } from "../../plugins/alert";
import { getFieldValue,deepCopy } from "../../plugins/utility";
import { getPharmacyWholesalerList,getHeadMedicineMark } from "../../plugins/pharmacy";
import { initialOrderPackData,initialPackSubmitWaitData } from "../..//plugins/order";

import { uuid } from 'vue-uuid';
import qs from 'qs';
import axios from '../../plugins/axios.ts';
import { useOrderStore } from '../../stores/order';

const order = useOrderStore();

const props = defineProps({
    apis:{
      type:Object,
      required:true,
    },
    pharmacyWholesalers:{
      type:Array,
      required:true,
    },
    type:{
      type:String,
      required:true,
    },
    identityId:{
      type:Number,
      required:true,
    },
    item:{
      type:Object,
      required:true,
    },
    fields:{
      type:Array,
      default: () => {
          return [];
      }
    },
    joinFieldKey:{
      type:String,
      default: () => {
          return '';
      }
    },
    orderValues:{
      type:Array,
      default: () => {
          return [];
      }
    },
    orderPackValues:{
      type:Array,
      default: () => {
          return [];
      }
    },
    orderPackWaitValues:{
      type:Array,
      default: () => {
          return [];
      }
    },
    isPack:{
      type:Boolean,
      default: () => {
          return true;
      }
    },
    isTelephone:{
      type:Boolean,
      default: () => {
          return false;
      }
    },
    editStatusChange:{
      type:Function,
    },
    editTransactionStatusChange:{
      type:Function,
    },
    editOrderSelectChange:{
      type:Function,
    },
    editOrderCheckChange:{
      type:Function,
    },
    editOrderTextChange:{
      type:Function,
    },
    editSettingComplete:{
      type:Function,
    },
    editOrderPackComplete:{
      type:Function,
    },
    editOrderPackWaitCancel:{
      type:Function,
    },
    editOrderPackWaitTextChange:{
      type:Function,
    },
    onEnterOrderText:{
      type:Function,
    },
    editPharmacyMedicineTagChange:{
      type:Function,
    },
    packSubmitWaitEditChange:{
      type:Function,
    },
})

const listPharmacyRelationRef = ref();
const inputElement = ref();

const editSelectChange = (value,label,option) => {
  if (option.type == 'medicine') {
    //小分け情報は削除する（包装が変わっているので条件等が変わってしまっているため）
    if (typeof props.editOrderPackComplete !== 'undefined') {
      let records = getOrderPackDataList(option.id);
      for (let i=0;i<records.length;i++) {
        props.editOrderPackComplete(deepCopy(records[i]),true);
      }
    }
  }
  if (typeof props.editOrderSelectChange !== 'undefined') {
    props.editOrderSelectChange(value,label,option);
  }
}
const editCheckChange = (value,option) => {
  if (typeof props.editOrderCheckChange !== 'undefined') {
    props.editOrderCheckChange(value,option);
  }
}
const isMedicineHistoryDialog = ref(false);
const historyMedicineName = ref('');
const historyMedicineYjCode = ref('');
const showMedicineHistoryDialog = (item) => {
  historyMedicineYjCode.value = item.yj_code;
  historyMedicineName.value = item.product_name;
  isMedicineHistoryDialog.value = true;
}
const closeMedicineHistoryDialog = (item) => {
  isMedicineHistoryDialog.value = false;
}
const detailYjCode = ref('');
const isMedicineDetailDialog = ref(false);
const showMedicineDetailDialog = (item) => {
  detailYjCode.value = item.yj_code;
  isMedicineDetailDialog.value = true;
}
const closeMedicineDetailDialog = (item) => {
  isMedicineDetailDialog.value = false;
}
const isLoading = ref(false);
const updatePharmacyMedicineStatus = async (pharmacyMedicineId,status) => {
  let params = new FormData();
  params.append('pharmacy_medicine_id', pharmacyMedicineId);
  params.append(status, 1);
  isLoading.value = true;
  try {
    const response = await axios(props.apis.pharmacy_medicine_status_update,{method:"post",data:params});
    if (response.data.status == 200) {
      if (typeof props.editStatusChange !== 'undefined') {
        props.editStatusChange(pharmacyMedicineId,status);
      }
    }
  } finally {
    isLoading.value = false;
  }
}

const defectData = reactive({id:0,product_name:'',number:0,package_unit:'',stock_type:0});
const isEditPharmacyMedicineDefectDialog = ref(false);
const showEditPharmacyMedicineDefect = (item) => {
  defectData.id = item.id;
  defectData.stock_type = item.stock_type;
  defectData.product_name = item.product_name + ' ' + item.package_label;
  defectData.number = (item.lot_number > 0 ? item.lot_number : item.number);
  defectData.pre_number = defectData.number;
  defectData.package_unit = (item.lot_number > 0 ? '' : item.medicine.package_unit);
  isEditPharmacyMedicineDefectDialog.value = true;
}
const closeEditPharmacyMedicineDefect = () => {
  isEditPharmacyMedicineDefectDialog.value = false;
}
const defectPharmacyMedicineConfirm = async () => {
  if (defectData.stock_type == config.STOCK_TYPES['小分け']) {
    let result = await confirmAlert('小分け取引は実行すると元に戻せません。実行しますか？');
    if (result.isConfirmed) {
      updatePharmacyStockTransactionStatus(defectData.id,0,defectData.number)
    }
  } else {
      updatePharmacyStockTransactionStatus(defectData.id,0,defectData.number)
  }
}

const defectPharmacyMedicine = async () => {
  updatePharmacyStockTransactionStatus(defectData.id,0,defectData.number)
}
const onDefectNumberChange = (value) => {
  defectData.number = value;
}
const updatePharmacyStockTransactionStatus = async (stockId,status,defectNumber=0) => {
  let params = new FormData();
  params.append('stock_id', stockId);
  params.append('status', status);
  params.append('defect_number', defectNumber);
  isLoading.value = true;
  try {
    const response = await axios(props.apis.pharmacy_stock_update_transaction_status,{method:"post",data:params});
    if (response.data.status == 200) {
      if (typeof props.editTransactionStatusChange !== 'undefined') {
        props.editTransactionStatusChange(props.identityId,status,(defectNumber > 0 ? defectData.pre_number - defectNumber : 0));
      }
      closeEditPharmacyMedicineDefect();
    }
  } finally {
    isLoading.value = false;
  }
}
const updatePharmacyDefectTransactionStatusConfirm = async (defectId,reverse=false) => {
  let result = await confirmAlert((reverse == false ? '実行すると元に戻せません。返品処理を確定しますか？' : '納品待ちに戻しますか？'));
  if (result.isConfirmed) {
    updatePharmacyDefectTransactionStatus(defectId,reverse)
  }
}

const updatePharmacyDefectTransactionStatus = async (defectId,reverse=false) => {
  let params = new FormData();
  params.append('defect_id', defectId);
  params.append('reverse', (reverse == false ? 0 : 1));
  isLoading.value = true;
  try {
    const response = await axios(props.apis.pharmacy_stock_update_transaction_status,{method:"post",data:params});
    if (response.data.status == 200) {
      if (typeof props.editTransactionStatusChange !== 'undefined') {
        props.editTransactionStatusChange(props.identityId,status,0);
      }
    } else {
      errorAlert(response.data.message);
    }
  } finally {
    isLoading.value = false;
  }
}

const yjCode = ref('');
const isEditPharmacyMedicineDialog = ref(false);
const showEditPharmacyMedicine = (item) => {
  yjCode.value = item.yj_code;
  isEditPharmacyMedicineDialog.value = true;
}
const closeEditPharmacyMedicine = () => {
  isEditPharmacyMedicineDialog.value = false;
  yjCode.value = '';
}
const updateCompleteMedicine = (data) => {
  closeEditPharmacyMedicine();
  if (typeof props.editSettingComplete !== 'undefined') {
    props.editSettingComplete();
  }
}

const getPharmacyMedicineItem = (pharmacyMedicineId) => {
  let item = null;
  for (let i=0;i<props.item.pharmacy_medicine_list.length;i++) {
    if (props.item.pharmacy_medicine_list[i].id == pharmacyMedicineId) {
      item = props.item.pharmacy_medicine_list[i];
      break;
    }
  }
  return item;
}
const selectWholesalerId = computed(() => {
  return (pharmacyMedicineId) => {
    let result = 0;
    let exists = false;
    for (let i=0;i<props.orderValues.length;i++) {
      if (props.orderValues[i].pharmacy_medicine_id == pharmacyMedicineId) {
        exists = true;
        result = props.orderValues[i].wholesaler_id;
        break;
      }
    }
    if (exists == false) {
      result = getPharmacyMedicineItem(pharmacyMedicineId).wholesaler_id;
    }
    return result;
  };
})
const selectAutoCommitCheck = computed(() => {
  return (pharmacyMedicineId) => {
    let result = false;
    for (let i=0;i<props.orderValues.length;i++) {
      if (props.orderValues[i].pharmacy_medicine_id == pharmacyMedicineId) {
        result = props.orderValues[i].commited;
        break;
      }
    }
    return result;
  };
})
const inputOrderNumber = computed(() => {
  return (pharmacyMedicineId) => {
    let result = 0;
    let exists = false;
    for (let i=0;i<props.orderValues.length;i++) {
      if (props.orderValues[i].pharmacy_medicine_id == pharmacyMedicineId) {
        result = props.orderValues[i].lot_number;
        exists = true;
        break;
      }
    }
    if ((exists == false) && (props.type == 'is_auto')) {
      for (let i=0;props.item.pharmacy_medicine_list.length;i++) {
        if (props.item.pharmacy_medicine_list[i].id == pharmacyMedicineId) {
          result = props.item.pharmacy_medicine_list[i].predict_quantity_lot_number;
          break;
        }
      }
    }
    return result;
  };
})
const pharmacyWholesalerList = computed(() => {
  return (pharmacyMedicineId) => {
    return getPharmacyWholesalerList(props.item,pharmacyMedicineId);
  }
});

const isPharmacyMedicinePackDialog = ref(false);
const pharmacyMeidicinePackIdentityId = ref(0);
const isPackType = ref(0);
const pharmacyPackRef = ref();
const showPharmacyMedicinePackDialog = async (id,medicineId,isPackTypeValue,medicineGroupId,medicineGroupName,pharmacy) => {
  isPackType.value = isPackTypeValue;
  isPharmacyMedicinePackDialog.value = true;
  await pharmacyPackRef.value.showPharmacyMedicinePack(id,medicineId,isPackTypeValue,medicineGroupId,medicineGroupName,pharmacy)
}
const closePharmacyMedicinePackDialog = () => {
  isPharmacyMedicinePackDialog.value = false;
}
const submitPharmacyMedicinePackDialog = (data) => {
  if (typeof props.editOrderPackComplete !== 'undefined') {
    props.editOrderPackComplete(data);
  }
  closePharmacyMedicinePackDialog();
}
const deleteOrderPackData = (pharmacyMedicineId,medicineGroupId,medicineGroupName,pharmacy) => {
  if (typeof props.editOrderPackComplete !== 'undefined') {
    props.editOrderPackComplete(deepCopy(pharmacyPackRef.value.getOrderPackData(pharmacyMedicineId,medicineGroupId,pharmacy.id)),true);
  }
}
const getOrderPackDataList = (pharmacyMedicineId) => {
  let result = [];
  for (let i=0;i<props.orderPackValues.length;i++) {
    if (props.orderPackValues[i].pharmacy_medicine_id == pharmacyMedicineId) {
      result.push(props.orderPackValues[i]);
    }
  }
  return result;
}
const orderPackDataList = computed(() => {
  return (pharmacyMedicineId) => {
    return getOrderPackDataList(pharmacyMedicineId);
  };
});
const isEditAlert = computed(() => {
  return (pharmacyMedicineId,type) => {
    let result = false;
    for (let i=0;i<props.orderValues.length;i++) {
      if (props.orderValues[i].pharmacy_medicine_id == pharmacyMedicineId) {
        if (type == 'lot_number' && props.orderValues[i].lot_number <= 0) {
          result = true;
        } else if (type == 'wholesaler_id' && props.orderValues[i].wholesaler_id == 0) {
          result = true;
        } else if (type == 'commited' && props.orderValues[i].commited == false) {
          result = true;
        }
        break;
      }
    }
    return result;
  };
});
const isWholesalerChanged = computed(() => {
  return (pharmacyMedicineId) => {
    let result = false;
    for (let i=0;i<props.orderValues.length;i++) {
      if (props.orderValues[i].pharmacy_medicine_id == pharmacyMedicineId) {
        if (props.orderValues[i].wholesaler_id != props.orderValues[i].wholesaler_old_id)
        result = true;
        break;
      }
    }
    return result;
  };
});
const isOrderDataEdit = computed(() => {
  return (pharmacyMedicineId) => {
    let result = false;
    for (let i=0;i<props.orderValues.length;i++) {
      if (props.orderValues[i].pharmacy_medicine_id == pharmacyMedicineId) {
        result = true;
        break;
      }
    }
    for (let i=0;i<props.orderPackValues.length;i++) {
      if (props.orderPackValues[i].pharmacy_medicine_id == pharmacyMedicineId) {
        result = true;
        break;
      }
    }
    return result;
  };
});

const isHoverPrescripFlg = ref(false);
const hoverPrescriptYjCode = ref('');
const hoverPrescriptIdentityId = ref(0);
const leavePrescript = () => {
  isHoverPrescripFlg.value = false;
}
const showHoverPrescript = (yjCode) => {
  if (isHoverPrescripFlg.value == false) {
    hoverPrescriptYjCode.value = yjCode;
  }
  isClosing.value = true;
  hoverPrescriptIdentityId.value++;
  isHoverPrescripFlg.value = !isHoverPrescripFlg.value;
}
const onPredictCoverComplete = () => {
  if (typeof props.editSettingComplete !== 'undefined') {
    props.editSettingComplete();
  }
}
const {element,isClosing,clickOutside} = CustomEvent(leavePrescript)
onMounted(() => {
  window.addEventListener('click', clickOutside);
});
onBeforeUnmount(() => {
  window.removeEventListener('click', clickOutside);
});

const tableBaseFields = computed(() => {
  let result = [];
  for (let i=0;i<props.fields.length;i++) {
    result.push(props.fields[i]);
  }
  return result;
})
const tableJoinFields = computed(() => {
  let result = [];
  for (let i=0;i<props.fields.length;i++) {
    if (typeof props.fields[i].is_join === 'undefined' || props.fields[i].is_join == false) {
      continue;
    }
    result.push(props.fields[i]);
  }
  return result;
})
const joinItems = computed(() => {
  return (item,fromIndex = null,toIndex = null) => {
    if (props.joinFieldKey == '') {
      return [];
    }
    let result = [];
    for (let i=0;i<item[props.joinFieldKey].length;i++) {
      if (fromIndex != null && i < fromIndex) {
        continue;
      }
      if (toIndex != null && i > toIndex) {
        continue;
      }
      result.push(item[props.joinFieldKey][i]);
    }
    return result;
  };
})
const isTableJoinFieldCheck = (fieldKey) => {
  let result = false;
  for (let i=0;i<props.fields.length;i++) {
    if (props.fields[i].field_key == fieldKey) {
      if (typeof props.fields[i].is_join !== 'undefined' && props.fields[i].is_join == true) {
        result = true;
      }
      break;
    }
  }
  return result;
}
const isTableJoinField = computed(() => {
  return (fieldKey) => {
    return isTableJoinFieldCheck(fieldKey);
  };
})
const getBaseTableItem = computed(() => {
  return (item,fieldKey,isJoin = false) => {
    let result = item;
    if (isJoin == true || isTableJoinFieldCheck(fieldKey)) {
      result = item[props.joinFieldKey][0];
    }
    return result;
  };
})
////// タグ//////////////////
////// 小分け統一 /////////////////////////////////
const addPackWait = async (packStatus,item) => {
  let index = order.search_pack_submit_wait_by_id(packStatus,item.id);
  if (index == null) {
    let pharmacyPackSubmitWaits = [];
    for (let i=0;i<item.pharmacy_pack_submit_waits.length;i++) {
      pharmacyPackSubmitWaits.push(item.pharmacy_pack_submit_waits[i]);
    }
    pharmacyPackSubmitWaits.push({
      id:String(uuid.v4()),
      medicine_id:pharmacyPackSubmitWaits[0].medicine_id,
      number:0,
      lot_no:'',
      expire_date:'',
    });
    let record = initialPackSubmitWaitData(packStatus,item.id,item.medicine_type,item.stock_group_id,item.total_number,pharmacyPackSubmitWaits);
    order.create_pack_submit_wait(record);
  } else {
    let record = deepCopy(order.edit_pack_submit_wait_data[index.parent_index]);
    record.pharmacy_pack_submit_waits.push({
      id:String(uuid.v4()),
      medicine_id:record.pharmacy_pack_submit_waits[0].medicine_id,
      number:0,
      lot_no:'',
      expire_date:'',
    });
    order.update_pack_submit_wait(record);
  }
}
const deletePackWait = async (packStatus,pharmacyStockId) => {
  if (typeof pharmacyStockId === 'string' && pharmacyStockId.indexOf('-') != -1) {
    let index = order.search_pack_submit_wait_by_id(packStatus,pharmacyStockId);
    if (index != null && index.child_index != null) {
      order.delete_pack_submit_wait(index.parent_index,index.child_index);
    }
  } else {
    errorAlert('この行は削除出来ません。');
  }
}
const onChangePackSubmitWait = (value,option) => {
  let item = null;
  if (option.type == 'number') {
    value = Number(value);
  }
  let index = order.search_pack_submit_wait_by_id(option.pack_status,option.stock_id);
  if (index == null) {
    item = initialPackSubmitWaitData(option.pack_status,option.parent_stock_id,option.item.medicine_type,option.item.stock_group_id,option.item.total_number,option.item.pharmacy_pack_submit_waits);
    if (option.action == 'submit') {
      item.is_submitted = value;
      //取消状態は解消
      if (item.is_submitted) {
        item.is_canceled = false;
      }
    } else if (option.action == 'cancel') {
      item.is_canceled = value;
      //承認状態は解消
      if (item.is_canceled) {
        item.is_submitted = false;
      }
    } else {
      for (let i=0;i<item.pharmacy_pack_submit_waits.length;i++) {
        if (item.pharmacy_pack_submit_waits[i].id == option.stock_id) {
          item.pharmacy_pack_submit_waits[i][option.field_name] = value;
          break;
        }
      }
    }
    //フラグが全てOFFの場合はレコード削除の場合なので追加しない
    if (option.action == 'update' || item.is_submitted || item.is_canceled) {
      order.create_pack_submit_wait(item);
    }
  } else {
    item = order.edit_pack_submit_wait_data[index.parent_index];
    if (option.action == 'submit') {
      item.is_submitted = value;
      //取消状態は解消
      if (item.is_submitted) {
        item.is_canceled = false;
      }
    } else if (option.action == 'cancel') {
      item.is_canceled = value;
      //承認状態は解消
      if (item.is_canceled) {
        item.is_submitted = false;
      }
    } else {
      if (index.child_index != null) {
        item.pharmacy_pack_submit_waits[index.child_index][option.field_name] = value;
      } else {
        // TODO
      }
    }
    order.update_pack_submit_wait(item);
  }
  if (typeof props.packSubmitWaitEditChange !== 'undefined') {
    props.packSubmitWaitEditChange(item,option.pack_status,option.action);
  }
}
const inputPackSubmitWaitValue = computed(() => {
  return (type,packStatus,action,pharmacyStockId,fieldName) => {
    let value = (type == 'check' ? false : '');
    let index = order.search_pack_submit_wait_by_id(packStatus,pharmacyStockId);
    if (index != null) {
      if (action == 'submit') {
        value = order.edit_pack_submit_wait_data[index.parent_index].is_submitted;
      } else if (action == 'cancel') {
        value = order.edit_pack_submit_wait_data[index.parent_index].is_canceled;
      } else if (action == 'error') {
        value = order.edit_pack_submit_wait_data[index.parent_index][fieldName];
      } else {
        value = order.edit_pack_submit_wait_data[index.parent_index].pharmacy_pack_submit_waits[index.child_index][fieldName];
      }
    } else {
      if (action == 'update') {
        for (let i=0;i<props.item.pharmacy_pack_submit_waits.length;i++) {
          if (props.item.pharmacy_pack_submit_waits[i].id == pharmacyStockId) {
            value = props.item.pharmacy_pack_submit_waits[i][fieldName];
            break;
          }
        }
        for (let i=0;i<props.item.pharmacy_pack_submit_waits.length;i++) {
          if (props.item.pharmacy_pack_submit_waits[i].id == pharmacyStockId) {
            value = props.item.pharmacy_pack_submit_waits[i][fieldName];
            break;
          }
        }
      }
    }
    return value;
  }
})
const packSubmitWaitList = computed(() => {
  let result = [];
  for (let i=0;i<props.item.pharmacy_pack_submit_waits.length;i++) {
    result.push(props.item.pharmacy_pack_submit_waits[i]);
  }
  if (props.item.pack_status == config.PACK_STATUSES['発送待ち']) {
    let index = order.search_pack_submit_wait_by_id(props.item.pack_status,props.item.id);
    if (index != null) {
      for (let i=0;i<order.edit_pack_submit_wait_data[index.parent_index].pharmacy_pack_submit_waits.length;i++) {
        if (typeof order.edit_pack_submit_wait_data[index.parent_index].pharmacy_pack_submit_waits[i].id === 'string' && order.edit_pack_submit_wait_data[index.parent_index].pharmacy_pack_submit_waits[i].id.indexOf('-') != -1) {
          result.push(order.edit_pack_submit_wait_data[index.parent_index].pharmacy_pack_submit_waits[i]);
        }
      }
    }
  }
  return result;
});
const updatePharmacyPhackWaitCancel = async (targetStocks) => {
  let params = {
    stocks:targetStocks
  };
  isLoading.value = true;
  try {
    const response = await axios(props.apis.pharmacy_order_pack_wait_cancel_update,{method:"post",data:params});
    if (response.data.status == 200) {
      if (typeof props.editOrderPackWaitCancel !== 'undefined') {
        props.editOrderPackWaitCancel(response.data.count);
      }
    }
  } finally {
    isLoading.value = false;
  }
}
const updatePharmacyPackWaitCancelConfirm = async (item) => {
  updatePharmacyPhackWaitCancel([{
    id:item.id,
    medicine_id:item.medicine_id,
    lot_no:null,
    expire_date:null,
    number:item.number,
  }])
}
//////////////////////////////////
//////// バイタル出荷調整品 /////////////
const isEditVitalWaitMedicineDialog = ref(false);
const editVitalWaitMedicineIdentityId = ref(0);
const sameCode = ref('');
const showEditVitalWaitMedicine = (code) => {
  if (!code) {
    errorAlert('参考類似品がありません。');
    return;
  }
  sameCode.value = code;
  editVitalWaitMedicineIdentityId.value++;
  isEditVitalWaitMedicineDialog.value = true;
}
const closeEditVitalWaitMedicine = () => {
  isEditVitalWaitMedicineDialog.value = false;
}
const updateCompleteVitalWaitMedicine = (data) => {
  closeEditVitalWaitMedicine();
  if (typeof props.editSettingComplete !== 'undefined') {
    props.editSettingComplete();
  }
}
/////////////////////////////////////////
////// タグ機能//////////////////////////
const onChangePharmacyMedicineTag = (pharmacyMedicineId,tags) => {
  if (typeof props.editPharmacyMedicineTagChange !== 'undefined') {
    props.editPharmacyMedicineTagChange(pharmacyMedicineId,tags);
  }
}
////////////////////////////////////////
</script>

<style scoped>
.ptp-label {
  background-color: #f00;
  color: white;
  padding: 0.2rem 0.4rem;
  border-radius: 15px;
}
</style>
<template>
<td v-show="tableJoinFields.length == 0" v-for="(field,index) in tableBaseFields" :key="index" :style="'width:' + field.width" :class="field.align + (typeof item.order_status !== 'undefined' && item.order_status == config.ORDER_STATUSES['手動'] ? ' bg-yellow-200' : (typeof item.order_status !== 'undefined' && item.order_status == config.ORDER_STATUSES['代替'] ? ' bg-blue-100' : ''))">
  <div v-if="field.field_key == 'action_status'" class="flex flex-wrap">
    <div v-if="type == 'is_hold'" class="m-1">
      <button type="button" @click="updatePharmacyMedicineStatus(item.id,'is_self')" class="w-full py-2 px-2 text-xs font-medium text-gray-900 focus:outline-none bg-white rounded-full border border-gray-200 hover:bg-amber-300 hover:text-black focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">
        <svg aria-hidden="true" class="inline w-5 h-5 text-gray-400 group-hover:text-gray-500 dark:text-gray-500 dark:group-hover:text-gray-300" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M2.3,0C1.03,0,0,1.03,0,2.3v13.82c0,1.27,1.03,2.3,2.3,2.3H11.52c1.27,0,2.3-1.03,2.3-2.3V5.76h-4.61c-.64,0-1.15-.51-1.15-1.15V0H2.3Zm6.91,0V4.61h4.61L9.21,0Zm-1.44,14.68c0,.48-.39,.86-.86,.86s-.86-.39-.86-.86v-3.67l-1.12,1.12c-.34,.34-.89,.34-1.22,0s-.34-.89,0-1.22l2.59-2.59c.34-.34,.89-.34,1.22,0l2.59,2.59c.34,.34,.34,.89,0,1.22s-.89,.34-1.22,0l-1.12-1.12v3.67h0Z"></path></svg>
        戻す
      </button>
    </div>
    <div v-else class="m-1">
      <button type="button" @click="updatePharmacyMedicineStatus(item.id,'is_hold')" class="w-full mb-1 py-2 px-2 text-xs font-medium text-gray-900 focus:outline-none bg-white rounded-full border border-gray-200 hover:bg-amber-300 hover:text-black focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">
        <svg aria-hidden="true" class="inline w-5 h-5 text-gray-400 group-hover:text-gray-500 dark:text-gray-500 dark:group-hover:text-gray-300" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M8.5,17.01c4.7,0,8.5-3.81,8.5-8.5S13.2,0,8.5,0,0,3.81,0,8.5s3.81,8.5,8.5,8.5Zm-1.06-10.63v4.25c0,.59-.48,1.06-1.06,1.06s-1.06-.48-1.06-1.06V6.38c0-.59,.48-1.06,1.06-1.06s1.06,.48,1.06,1.06Zm4.25,0v4.25c0,.59-.48,1.06-1.06,1.06s-1.06-.48-1.06-1.06V6.38c0-.59,.48-1.06,1.06-1.06s1.06,.48,1.06,1.06Z"></path></svg>
        保留
      </button>
      <button v-show="item.order_status == config.ORDER_STATUSES['自動']" type="button" @click="updatePharmacyMedicineStatus(item.id,'is_reset')" class="w-full py-2 px-2 text-xs font-medium text-white focus:outline-none bg-red-500 rounded-full border border-gray-200 hover:bg-red-400 focus:z-10 focus:ring-4 focus:ring-gray-200 ">
        予測リセット
      </button>
    </div>
  </div>
  <div v-else-if="field.field_key == 'product_name'">
    <div><a href="javascript:void(0)" class="text-amber-700" @click="showMedicineDetailDialog(item)">{{ item.product_name }}</a><span v-html="item.warning_mark"></span></div>
    <span v-show="(typeof item.transitional_measure_date !== 'undefined' && item.transitional_measure_date)" class="inline-block text-sm m-1 p-1 rounded-full text-white bg-red-600">{{ '経過措置:' + item.transitional_measure_date }}</span>
    <div v-if="typeof item.tags !== 'undefined'">
      <pharmacy-medicine-tag-component
        :tags="item.tags"
        :apis="apis"
        :pharmacy-medicine-id="item.id"
        :submit="onChangePharmacyMedicineTag"
      ></pharmacy-medicine-tag-component>
    </div>
  </div>
  <div v-else-if="field.field_key == 'product_detail_name'">
    <div><a href="javascript:void(0)" class="text-amber-700" @click="showMedicineDetailDialog(item)">{{ (getFieldValue(item,'product_name') + ' ' + getFieldValue(item,'package_label')) }}</a><span v-html="item.warning_mark"></span></div>
    <span v-show="(typeof item.transitional_measure_date !== 'undefined' && item.transitional_measure_date)" class="inline-block text-sm m-1 p-1 rounded-full text-white bg-red-600">{{ '経過措置:' + item.transitional_measure_date }}</span>
  </div>
  <div v-else-if="field.field_key == 'real_stock_number'" class="flex flex-col items-center">
    <div>{{ getFieldValue(item,'real_stock_number').toLocaleString() + getFieldValue(item,'package_unit') }}</div>
    <div class="flex flex-row items-center">
      <div class="mr-2"><a href="javascript:void(0)" @click="showMedicineHistoryDialog(item)"><i class="fa-solid fa-list"></i></a></div>
      <div class="relative">
        <a href="javascript:void(0)" class="relative cursor-default mr-2" @click="showHoverPrescript(item.yj_code)">
          <i class="fa-solid fa-user"></i>
        </a>
        <div ref="element" v-show="isHoverPrescripFlg" class="absolute top-5 left-0 w-auto" style="z-index:2">
          <prescript-analyze-list-component
            :apis="apis"
            :is-predict-carry="true"
            :yj-code="hoverPrescriptYjCode"
            :identity-id="hoverPrescriptIdentityId"
            :pharmacy-medicine-id="item.id"
            :on-predict-cover-complete="onPredictCoverComplete"
          ></prescript-analyze-list-component>
        </div>
      </div>
    </div>
  </div>
  <div v-else-if="field.field_key == 'stock_number'" class="flex flex-col items-center">
    <div :class="(item.real_stock_number != item.stock_number ? ' text-red-700 text-bold ' : '')">{{ getFieldValue(item,'stock_number').toLocaleString() + getFieldValue(item,'package_unit') }}  <span v-show="item.is_max_number_days_alert" class="text-red-700 text-bold"> <i class="fa-solid fa-triangle-exclamation"></i></span></div>
  </div>
  <div v-else-if="field.field_key == 'action_setting'">
    <div>
      <a href="javascript:void(0)" @click="showEditPharmacyMedicine(item)"><i class="fa-solid fa-gear"></i></a>
    </div>
  </div>
  <div v-else-if="field.field_key == 'action_medicine_order'" class="flex flex-col items-center">
    <div :class="'border pr-1 pl-1 w-full ' + (isOrderDataEdit(pharmacy_medicine.id) ? ' border-blue-500 rounded' : '') + (pharmacy_medicine.medicine_predict_id !== null ? ' bg-gray-300' : '')" v-for="(pharmacy_medicine,index) in item.pharmacy_medicine_list" :key="pharmacy_medicine.id">
      <div>
        <div>
          <div class="flex flex-row items-center w-full">
            <div class="m-1 w-3/4 text-left">
              <span class="text-bold text-lg">{{ pharmacy_medicine.package_label }}</span><span v-html="pharmacy_medicine.is_head_managed ? getHeadMedicineMark() : ''"></span><span class="ml-4">在庫：{{ pharmacy_medicine.real_stock_number.toLocaleString() }}<span v-show="pharmacy_medicine.real_stock_number != pharmacy_medicine.stock_number" class="text-red-700">({{ pharmacy_medicine.stock_number.toLocaleString() }})</span> {{ pharmacy_medicine.package_unit }}</span> <span>\{{ pharmacy_medicine.current_package_price.toLocaleString() }}</span> <span>小計:\{{ (inputOrderNumber(pharmacy_medicine.id)*pharmacy_medicine.current_package_price).toLocaleString() }}</span>
            </div>
            <div :class="'m-1 w-1/4 ' + (isEditAlert(pharmacy_medicine.id,'lot_number') ? 'border border-red-700' : '')">
              <text-box
                ref="inputElement"
                type="number"
                :identity-id="String(pharmacy_medicine.id)"
                :minimun-number="0"
                :value="inputOrderNumber(pharmacy_medicine.id)"
                :value-options="{type:'lot_number',id:pharmacy_medicine.id}"
                :on-change="editOrderTextChange"
                :on-enter="onEnterOrderText"
                :is-focus-clear="true"
              ></text-box>
            </div>
          </div>
        </div>
        <div>
          <div class="flex flex-row items-center w-full">
            <div :class="'m-1 w-2/4 ' + (isEditAlert(pharmacy_medicine.id,'wholesaler_id') ? 'border border-red-700' : (isWholesalerChanged(pharmacy_medicine.id) ? 'border border-cyan-700' : ''))">
              <select-box
                :value="selectWholesalerId(pharmacy_medicine.id)"
                :options="pharmacyWholesalerList(pharmacy_medicine.id)"
                list-field-name="wholesaler_name"
                :value-options="{type:'wholesaler',id:pharmacy_medicine.id}"
                :on-change="editSelectChange"
                :is-searchable="false"
                place-holder="発注卸を選択"
              ></select-box>
            </div>
            <div :class="'m-1 w-1/4 flex flex-row ' + (isEditAlert(pharmacy_medicine.id,'commited') ? 'border border-red-700' : '')">
              <check-box
                label='<i class="fa-solid fa-truck"></i>'
                :value="selectAutoCommitCheck(pharmacy_medicine.id)"
                :value-options="{type:'commited',id:pharmacy_medicine.id}"
                :on-change="editCheckChange"
              ></check-box>
              <button v-show="pharmacy_medicine.is_vital_wait" @click="(pharmacy_medicine.replace_count > 0 ? showEditVitalWaitMedicine(pharmacy_medicine.chemical_code) : '')" class="block relative text-white focus:outline-none bg-red-500 m-1 py-1 px-2 text-xs font-xs rounded-full border border-gray-200 hover:bg-red-400 focus:z-10 focus:ring-4 focus:ring-gray-200">出荷調整中<span v-show="pharmacy_medicine.replace_count > 0" class="absolute -top-3 -right-1 text-xs border rounded-lg text-white bg-blue-500 border-blue-500">候補ｱﾘ</span></button>
              <span v-show="pharmacy_medicine.expensive_alert" class="ml-2"><img class="w-6 h-6" src="../../../public/images/icon/expensive_alert.png"></span>
            </div>
            <div class="m-1 w-1/4">
              <button v-show="item.establish_permit_upload_date.length > 0 && item.establish_permit_number.length > 0 && isPack" @click="showPharmacyMedicinePackDialog(pharmacy_medicine.id,pharmacy_medicine.medicine_id,0)" class="block relative text-gray-900 focus:outline-none bg-white m-1 py-1 px-2 text-xs font-medium rounded-full border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">小分け <span v-show="pharmacy_medicine.old_medicine_count > 0" :class="'absolute -top-3 -right-1 text-xs border rounded-lg text-white ' + (pharmacy_medicine.old_medicine_group_count > 0 ? 'bg-red-500 border-red-500' : 'bg-blue-500 border-blue-500')">{{ (pharmacy_medicine.old_medicine_group_count > 0 ? 'Gr' : '') }}不動ｱﾘ</span></button>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="flex flex-row items-center">
          <div v-show="orderPackDataList(pharmacy_medicine.id).length > 0" class="m-1 flex flex-wrap">
            <div class="m-1 px-2 py-1 border rounded-xl text-sm" v-for="orderPackRecord in orderPackDataList(pharmacy_medicine.id)" :key="orderPackRecord.pharmacy_medicine_id">
              <i class="fa-solid fa-store"></i> {{ orderPackRecord.pharmacy.pharmacy_name }} \{{ orderPackRecord.unit_price.toLocaleString() }} {{ orderPackRecord.number.toLocaleString() + orderPackRecord.medicine.package_unit }} <a href="javascript:void(0)" class="cursor-pointer ml-1" @click="showPharmacyMedicinePackDialog(orderPackRecord.pharmacy_medicine_id,orderPackRecord.medicine.id,0,orderPackRecord.medicine_group_id,orderPackRecord.medicine_group_name,orderPackRecord.pharmacy)"><i class="fa-solid fa-pen-to-square"></i></a><a href="javascript:void(0)" class="cursor-pointer ml-1" @click="deleteOrderPackData(orderPackRecord.pharmacy_medicine_id,orderPackRecord.medicine_group_id,orderPackRecord.medicine_group_name,orderPackRecord.pharmacy)"><i class="fa-solid fa-trash"></i></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else-if="field.field_key == 'prescript_predict_quantity_number'" :class="field.align">
    {{ item.prescript_predict_quantity_number.toLocaleString() + item.package_unit }}
    <span v-if="item.prescript_predict_quantity_number < item.stock_number && item.ptp_count > 0 && item.prescript_predict_quantity_number > item.ptp_stock_number" class="ptp-label">PTP</span>
    <!--
    {{ item.unexpected_prescript_number ? '(対象外:' + item.unexpected_prescript_number.toLocaleString() + ')' : '' }}
    {{ item.ordered_number && item.ordered_number > 0 ? '(発注済み:' + item.ordered_number.toLocaleString() + ')' : '' }}
    {{ item.carry_over_number ? '(繰越:' + item.carry_over_number.toLocaleString() + ')' : '' }}
    -->
  </div>
  <div v-else-if="field.field_key == 'warning_mark'" :class="field.align">
    <span v-html="item.warning_mark"></span>
  </div>
  <div v-else-if="field.field_key == 'order_number'">
    {{ getFieldValue(item,'predict_quantity_lot_number').toLocaleString() + getFieldValue(item,'package_unit') }}
  </div>
  <div v-else-if="field.field_key == 'action_wait'" class="flex flex-wrap">
    <!--<div class="m-1">
      <button type="button" @click="updatePharmacyStockTransactionStatus(item.id,1)" class="w-full py-2 px-2 text-xs font-medium text-gray-900 focus:outline-none bg-white rounded-full border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">確認完了</button>
    </div>-->
    <div class="m-1">
      <button type="button" @click="showEditPharmacyMedicineDefect(item)" class="w-full py-2 px-2 text-xs font-medium text-white focus:outline-none bg-red-700 rounded-full border border-gray-200 hover:bg-red-600 hover:text-white focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">未納品削除</button>
    </div>
  </div>
  <div v-else-if="field.field_key == 'action_wait_reverse'" class="flex flex-wrap">
    <div class="m-1">
      <button type="button" @click="updatePharmacyStockTransactionStatus(item.id,2)" class="w-full py-2 px-2 text-xs font-medium text-gray-900 focus:outline-none bg-white rounded-full border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">納品待ち</button>
    </div>
  </div>
  <div v-else-if="field.field_key == 'order_status'"  class="flex justify-center">
    <svg v-if="item.order_status == config.ORDER_STATUS['手動']" aria-hidden="true" class="w-5 h-5 text-gray-400 group-hover:text-gray-500 dark:text-gray-500 dark:group-hover:text-gray-300" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M9.07,0c-.9,0-1.67,.52-2.04,1.28-.25-.09-.51-.14-.79-.14-1.25,0-2.27,1.02-2.27,2.27v5.86l-.1-.1c-.89-.89-2.32-.89-3.21,0s-.89,2.32,0,3.21l3.11,3.11c1.7,1.7,4.01,2.66,6.41,2.66h.58c.05,0,.11,0,.16-.01,3.25-.22,5.85-2.81,6.06-6.06,.01-.05,.01-.11,.01-.16V5.67c0-1.25-1.02-2.27-2.27-2.27-.19,0-.39,.02-.57,.07v-.07c0-1.25-1.02-2.27-2.27-2.27-.28,0-.55,.05-.79,.14-.37-.75-1.14-1.28-2.04-1.28Zm-.57,3.41h0v-1.14c0-.31,.26-.57,.57-.57s.57,.26,.57,.57v1.13h0v4.82c0,.47,.38,.85,.85,.85s.85-.38,.85-.85V3.4h0c0-.32,.26-.57,.57-.57s.57,.26,.57,.57v1.98h0v2.84c0,.47,.38,.85,.85,.85s.85-.38,.85-.85v-2.54h0c0-.32,.26-.57,.57-.57s.57,.26,.57,.57v6.13s0,.05,0,.07c-.12,2.47-2.1,4.45-4.57,4.57-.02,0-.05,0-.07,0h-.47c-1.96,0-3.83-.78-5.21-2.16l-3.11-3.11c-.22-.22-.22-.58,0-.8s.58-.22,.8,0l1.55,1.55c.24,.24,.61,.32,.93,.18s.52-.44,.52-.79V3.4c0-.31,.26-.57,.57-.57s.57,.25,.57,.56v4.82c0,.47,.38,.85,.85,.85s.85-.38,.85-.85V3.41Z"></path></svg>
    <svg v-else aria-hidden="true" class="w-5 h-5 text-gray-400 group-hover:text-gray-500 dark:text-gray-500 dark:group-hover:text-gray-300" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M3.62,3.62c0-.59-.48-1.06-1.06-1.06s-1.06,.48-1.06,1.06V14.78c0,1.47,1.19,2.66,2.66,2.66h13.29c.59,0,1.06-.48,1.06-1.06s-.48-1.06-1.06-1.06H4.15c-.29,0-.53-.24-.53-.53V3.62Zm13.51,2.88c.42-.42,.42-1.09,0-1.5s-1.09-.42-1.5,0l-3.5,3.5-1.91-1.91c-.42-.42-1.09-.42-1.5,0l-3.72,3.72c-.42,.42-.42,1.09,0,1.5s1.09,.42,1.5,0l2.97-2.97,1.91,1.91c.42,.42,1.09,.42,1.5,0l4.25-4.25h0Z"></path></svg>
  </div>
  <div v-else-if="field.field_key == 'order_target_type'">
    <div v-if="getFieldValue(item,'stock_type') == 1">
      <span class="label-van">卸</span>
      <span v-show="item.pharmacy_van != null && item.pharmacy_van.receive_response_code != null" class="inline-block text-xs m-0.5 rounded-full text-blue-700 border border-blue-700">配送待ち</span>
      <span v-show="item.pharmacy_van != null && item.pharmacy_van.create_type == config.VAN_CREATE_TYPES['発注無し納品']" class="inline-block text-xs m-0.5 rounded-full text-red-700 border border-red-700">電話発注</span>
      <span v-show="item.pharmacy_van != null && item.pharmacy_van.create_type == config.VAN_CREATE_TYPES['新薬納品']" class="inline-block text-xs m-0.5 rounded-full text-red-700 border border-red-700">新薬納品</span>
      <span v-show="item.pharmacy_van != null && item.pharmacy_van.create_type == config.VAN_CREATE_TYPES['分割納品']" class="inline-block text-xs m-0.5 rounded-full text-red-700 border border-red-700">分割納品</span>
      <span v-show="item.is_wait" class="inline-block text-xs m-0.5 rounded-full text-orange-500 border border-orange-500">納品不足待ち</span>
    </div>
    <div v-else>
      <span class="label-pack">小分け</span>
      <span v-show="item.pharmacy_pack != null && item.pharmacy_pack.permit_date" class="inline-block text-xs m-0.5 rounded-full text-red-700 border border-red-700">承認</span>
      <span v-show="item.pharmacy_pack != null && item.pharmacy_pack.delivery_date" class="inline-block text-xs m-0.5 rounded-full text-blue-700 border border-blue-700">発送</span>
    </div>
  </div>
  <div v-else-if="field.field_key == 'order_target'">
    <div v-if="getFieldValue(item,'stock_type') == 1">
      {{ getFieldValue(item.pharmacy_van.wholesaler,'wholesaler_name') }}
    </div>
    <div v-else>
      {{ getFieldValue(item.pharmacy_pack.to_pharmacy,'pharmacy_name') }}
    </div>
  </div>
  <div v-else-if="field.field_key == 'ordered_number'">
    {{ (getFieldValue(item,'stock_type') == 1 ? Math.abs(getFieldValue(item,'lot_number')).toLocaleString() : Math.abs(getFieldValue(item,'number')).toLocaleString() + getFieldValue(item.medicine,'package_unit')) }}
    <span v-show="item.is_wait" class="text-red-800"><i class="fa-solid fa-truck-droplet"></i></span>
  </div>
  <div v-else-if="field.field_key == 'defected_number'">
    <div class="border p-1 w-full flex flex-row items-center" v-for="(pharmacy_defect,index) in item.pharmacy_defects" :key="pharmacy_defect.id">
      <div class="m-1 w-1/4">
        {{ (getFieldValue(item,'stock_type') == 1 ? getFieldValue(pharmacy_defect,'lot_number').toLocaleString() : getFieldValue(pharmacy_defect,'number').toLocaleString() + getFieldValue(item.medicine,'package_unit')) }}
      </div>
      <div class="m-1 w-2/4">
        <span class="rounded p-1 bg-gray-200"><i class="fa-regular fa-clock"></i> {{ getFieldValue(pharmacy_defect,'defect_date') }}</span>
      </div>
      <div class="m-1 w-1/4">
        <div class="flex flex-row items-center">
          <div><button type="button" @click="updatePharmacyDefectTransactionStatusConfirm(pharmacy_defect.id,true)" class="w-full py-2 px-2 text-xs font-medium text-white focus:outline-none bg-red-600 rounded-full border border-red-200 hover:bg-red-700 hover:text-white focus:z-10 focus:ring-4 focus:ring-red-200 dark:focus:ring-red-700 dark:bg-red-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700 mr-1">納品待ちに戻す</button></div>
          <div><button type="button" @click="updatePharmacyDefectTransactionStatusConfirm(pharmacy_defect.id)" class="w-full py-2 px-2 text-xs font-medium text-gray-900 focus:outline-none bg-white rounded-full border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">削除確定</button></div>
        </div>
      </div>
    </div>
  </div>
  <div v-else-if="field.field_key == 'slip_info'" :class="field.align">
    {{ getFieldValue(item,'slip_info') }}
  </div>
  <div v-else :class="field.align">
    {{ getFieldValue(item,field.field_key) }}
  </div>
</td>
<tr v-show="tableJoinFields.length > 0" class="border-b border-gray-400">
  <td :rowspan="isTableJoinField(field.field_key) == false && joinItems(item).length > 1 ? joinItems(item).length : ''" v-for="(field,index) in tableBaseFields" :key="index">
    <div v-if="field.field_key == 'product_name'" :class="field.align">
      <div><a href="javascript:void(0)" class="text-amber-700" @click="showMedicineDetailDialog(item)">{{ getFieldValue(getBaseTableItem(item,field.field_key),'product_name') }}</a><span v-html="getFieldValue(getBaseTableItem(item,field.field_key),'warning_mark')"></span></div>
    </div>
    <div v-else-if="field.field_key == 'number'" :class="field.align">
      {{ Math.abs(getFieldValue(getBaseTableItem(item,field.field_key),'number')).toLocaleString() + getFieldValue(getBaseTableItem(item,field.field_key),'package_unit') }}
    </div>
    <div v-else-if="field.field_key == 'pack_to_pharmacy'" :class="'flex flex-wrap ' + field.align">
      <a href="javascript:void(0)" class="block text-amber-600" @click="showPharmacyMedicinePackDialog(getFieldValue(getBaseTableItem(item,field.field_key),'id'),getFieldValue(getBaseTableItem(item,field.field_key),'medicine_id'),1)">{{ getFieldValue(getBaseTableItem(item,field.field_key),'to_pharmacy_name') }}</a>
    </div>
    <div v-else-if="field.field_key == 'unit_price'" :class="field.align">
      \{{ getFieldValue(getBaseTableItem(item,field.field_key),'unit_price').toLocaleString() }}
    </div>
    <div v-else-if="field.field_key == 'pack_status'" :class="field.align">
      <div v-if="getFieldValue(getBaseTableItem(item,field.field_key),'pack_status') == config.PACK_STATUSES['承認待ち']" class="">
        <span class="inline-block text-xs m-0.5 rounded-full text-red-700 border border-red-700">承認待ち</span>
      </div>
      <div v-else>
        <span class="inline-block text-xs m-0.5 rounded-full text-blue-700 border border-blue-700">発送待ち</span>
      </div>
    </div>
    <div v-else-if="field.field_key == 'action_pack_submit_wait'" :class="'flex flex-row items-center ' + field.align">
      <div v-if="getFieldValue(item,'pack_status') == config.PACK_STATUSES['承認待ち']" class="flex flex-row items-center">
        <div class="mr-2">
          <check-box
            label='<span class="text-blue-500">承認</span>'
            :value="inputPackSubmitWaitValue('check',getFieldValue(item,'pack_status'),'submit',getFieldValue(item,'id'),'is_submitted')"
            :value-options="{type:'check',item:item,pack_status:getFieldValue(item,'pack_status'),action:'submit',parent_stock_id:getFieldValue(item,'id'),stock_id:getFieldValue(item,'id')}"
            :on-change="onChangePackSubmitWait"
          ></check-box>
        </div>
        <div class="">
          <check-box
            label='<span class="text-red-500">取消</span>'
            :value="inputPackSubmitWaitValue('check',getFieldValue(item,'pack_status'),'cancel',getFieldValue(item,'id'),'is_canceled')"
            :value-options="{type:'check',item:item,pack_status:getFieldValue(item,'pack_status'),action:'cancel',parent_stock_id:getFieldValue(item,'id'),stock_id:getFieldValue(item,'id')}"
            :on-change="onChangePackSubmitWait"
          ></check-box>
        </div>
      </div>
      <div v-else class="flex flex-row items-center">
        <div class="mr-2">
          <check-box
            label='<span class="text-amber-500">発送</span>'
            :value="inputPackSubmitWaitValue('check',getFieldValue(item,'pack_status'),'submit',getFieldValue(item,'id'),'is_submitted')"
            :value-options="{type:'check',item:item,pack_status:getFieldValue(item,'pack_status'),action:'submit',parent_stock_id:getFieldValue(item,'id'),stock_id:getFieldValue(item,'id')}"
            :on-change="onChangePackSubmitWait"
          ></check-box>
        </div>
        <div class="">
          <check-box
            label='<span class="text-red-500">取消</span>'
            :value="inputPackSubmitWaitValue('check',getFieldValue(item,'pack_status'),'cancel',getFieldValue(item,'id'),'is_canceled')"
            :value-options="{type:'check',item:item,pack_status:getFieldValue(item,'pack_status'),action:'cancel',parent_stock_id:getFieldValue(item,'id'),stock_id:getFieldValue(item,'id')}"
            :on-change="onChangePackSubmitWait"
          ></check-box>
        </div>
      </div>
    </div>
    <div v-else-if="field.field_key == 'edit_pack_submit_wait'" :class="'flex flex-col ' + (inputPackSubmitWaitValue('check',getFieldValue(item,'pack_status'),'error',getFieldValue(item,'id'),'is_error') ? ' border-2 border-red-500' : '')">
      <div v-show="inputPackSubmitWaitValue('check',getFieldValue(item,'pack_status'),'error',getFieldValue(item,'id'),'is_error')" class="text-bold text-red-500">{{ inputPackSubmitWaitValue('text',getFieldValue(item,'pack_status'),'error',getFieldValue(item,'id'),'error_message') }}</div>
      <div v-if="getFieldValue(item,'pack_status') == config.PACK_STATUSES['承認待ち']" class="flex flex-col w-full">
        <div v-for="(child,index) in packSubmitWaitList" :key="child.id" class="flex flex-col items-center mb-1">
          <div v-if="index == 0 && child.to_pharmacy_note" class="w-full mb-1">取引メモ:{{ child.to_pharmacy_note }}</div>
          <div class="w-full mb-1">【{{ child.package_label }}】</div>
          <div class="w-full flex flex-row items-center">
            <div class="w-5/12 pr-1">実在庫:{{ child.real_stock_number.toLocaleString() }}{{ child.package_unit }}</div>
            <div class="w-6/12">
              <text-box
                  ref="inputRefs"
                  type="number"
                  place-holder="取引数量"
                  :identity-id="String(getFieldValue(getBaseTableItem(child,field.field_key),'id'))"
                  :value="inputPackSubmitWaitValue('check',getFieldValue(item,'pack_status'),'update',getFieldValue(child,'id'),'number')"
                  :value-options="{type:'number',item:item,pack_status:getFieldValue(item,'pack_status'),action:'update',parent_stock_id:getFieldValue(item,'id'),stock_id:getFieldValue(child,'id'),field_name:'number'}"
                  :on-change="onChangePackSubmitWait"
                  :minimun-number="0"
                  :is-focus-clear="true"
              ></text-box>
            </div>
            <div class="w-1/12">{{ child.package_unit }}</div>
          </div>
        </div>
      </div>
      <div v-else class="flex flex-col w-full">
        <div class="m-1" v-if="item.medicine_type != config.NON_MEDICINE_TYPES['OTC・雑貨']">
          <div class="border p-1 relative flex flex-col">
            <div v-for="(child,index) in packSubmitWaitList" :key="child.id" class="flex flex-row items-center mb-1">
              <div class="w-3/12">
                <text-box
                  ref="inputRefs"
                  type="text"
                  font-width="half"
                  place-holder="ロット番号"
                  :identity-id="String(getFieldValue(getBaseTableItem(child,field.field_key),'id'))"
                  :value="inputPackSubmitWaitValue('check',getFieldValue(item,'pack_status'),'update',getFieldValue(child,'id'),'lot_no')"
                  :value-options="{type:'text',item:item,pack_status:getFieldValue(item,'pack_status'),action:'update',parent_stock_id:getFieldValue(item,'id'),stock_id:getFieldValue(child,'id'),field_name:'lot_no'}"
                  :on-change="onChangePackSubmitWait"
                  :is-focus-clear="true"
                ></text-box>
              </div>
              <div class="pl-1 w-5/12">
                <!-- year_month -->
                <text-box
                  ref="inputRefs"
                  type="year_month"
                  :identity-id="String(getFieldValue(getBaseTableItem(item,field.field_key),'id'))"
                  :value="inputPackSubmitWaitValue('check',getFieldValue(item,'pack_status'),'update',getFieldValue(child,'id'),'expire_date')"
                  :value-options="{type:'text',item:item,pack_status:getFieldValue(item,'pack_status'),action:'update',parent_stock_id:getFieldValue(item,'id'),stock_id:getFieldValue(child,'id'),field_name:'expire_date'}"
                  :on-change="onChangePackSubmitWait"
                  :is-focus-clear="false"
                ></text-box>
              </div>
              <div class="pl-1 w-2/12">
                <text-box
                  ref="inputRefs"
                  type="number"
                  :identity-id="String(getFieldValue(getBaseTableItem(item,field.field_key),'id'))"
                  :value="inputPackSubmitWaitValue('check',getFieldValue(item,'pack_status'),'update',getFieldValue(child,'id'),'number')"
                  :value-options="{type:'number',item:item,pack_status:getFieldValue(item,'pack_status'),action:'update',parent_stock_id:getFieldValue(item,'id'),stock_id:getFieldValue(child,'id'),field_name:'number'}"
                  :minimun-number="0"
                  :on-change="onChangePackSubmitWait"
                  :is-focus-clear="false"
                ></text-box>
              </div>
              <div class="flex flex-row items-center w-2/12">
                <div v-show="index == (packSubmitWaitList.length-1)" class="ml-1">
                  <a href="javascript:void(0)" @click="addPackWait(getFieldValue(item,'pack_status'),item)" class="text-lg text-amber-500 text-bold"><i class="fa-solid fa-circle-plus"></i></a>
                </div>
                <div v-show="index != 0" class="ml-2">
                  <a href="javascript:void(0)" @click="deletePackWait(getFieldValue(item,'pack_status'),child.id)" class="text-lg text-red-500 text-bold"><i class="fa-solid fa-circle-minus"></i></a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="m-1" v-else>
          <div>OTC・雑貨はロット番号の登録は不要</div>
        </div>
      </div>
    </div>
    <div v-else-if="field.field_key == 'action_pack_reverse'" class="flex flex-wrap">
      <div class="m-1">
        <button type="button" @click="updatePharmacyPackWaitCancelConfirm(getBaseTableItem(item,field.field_key,true))" class="w-full py-2 px-2 text-xs font-medium text-gray-900 focus:outline-none bg-white rounded-full border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">発送待ち</button>
      </div>
    </div>
    <div v-else :class="field.align">
      {{ getFieldValue(getBaseTableItem(item,field.field_key),field.field_key) }}
    </div>
  </td>
</tr>
<tr v-show="joinItems(item).length > 1" v-for="(joinItem,index2) in joinItems(item,1)" :key="index2" class="border-b border-gray-400">
  <td v-for="(field,index) in tableJoinFields" :key="index">
    <div>
      <div v-if="field.field_key == 'package_label'" :class="field.align">
        {{ joinItem.package_label }}
        <span v-show="(typeof joinItem.medicine.transitional_measure_date) !== 'undefined' && joinItem.medicine.transitional_measure_date" class="inline-block text-sm m-1 p-1 rounded-full text-white bg-red-600">{{ '経過措置:' + joinItem.medicine.transitional_measure_date }}</span>
      </div>
      <div v-else-if="field.field_key == 'pack_to_pharmacy'" :class="'flex flex-wrap ' + field.align">
        <a href="javascript:void(0)" class="block text-amber-600" @click="showPharmacyMedicinePackDialog(joinItem.id,joinItem.medicine_id,1)">{{ joinItem.to_pharmacy_name }}</a>
      </div>
      <div v-else-if="field.field_key == 'number'" :class="field.align">
        {{ Math.abs(getFieldValue(joinItem,'number')).toLocaleString() + getFieldValue(joinItem.medicine,'package_unit') }}
      </div>
      <div v-else-if="field.field_key == 'unit_price'" :class="field.align">
        \{{ getFieldValue(joinItem,'unit_price').toLocaleString() }}
      </div>
      <div v-else :class="field.align">
        {{ getFieldValue(joinItem,field.field_key) }}
      </div>
    </div>
  </td>
</tr>

<modal-dialog
  :is-visible="isEditPharmacyMedicineDialog"
  width="95%"
  :close="closeEditPharmacyMedicine"
>
  <template v-slot:header>
    採用品編集
  </template>
  <template v-slot:default>
    <pharmacy-medicine-edit-component
      :apis="apis"
      :yj-code="yjCode"
      :pharmacy-wholesalers="pharmacyWholesalers"
      :is-medicine-fix="true"
      :cancel="closeEditPharmacyMedicine"
      :updateComplete="updateCompleteMedicine"
      :is-stock-control="true"
    ></pharmacy-medicine-edit-component>
  </template>
</modal-dialog>
<modal-dialog
  :is-visible="isPharmacyMedicinePackDialog"
  width="60%"
  :close="closePharmacyMedicinePackDialog"
>
  <template v-slot:header>
    小分け{{ (isPackType == 0 ? '発注' : '受注') }}
  </template>
  <template v-slot:default>
    <order-pack-component
      ref="pharmacyPackRef"
      :apis="apis"
      :identity-id="pharmacyMeidicinePackIdentityId"
      :submit="submitPharmacyMedicinePackDialog"
      :close="closePharmacyMedicinePackDialog"
      :order-pack-values="orderPackValues"
    ></order-pack-component>
  </template>
</modal-dialog>

<modal-dialog
  :is-visible="isEditPharmacyMedicineDefectDialog"
  width="60%"
  :close="closeEditPharmacyMedicineDefect"
>
  <template v-slot:header>
    未納品削除
  </template>
  <template v-slot:default>
    <div class="md:border p-2">
      <p>{{ defectData.product_name }}</p>
      <p class="text-red-600">※返品する数を入力してください。一度登録すると元に戻せませんのでご注意ください。</p>
      <div class="flex flex-row items-center">
        <div class="m-1">
          <text-box
            :value="defectData.number"
            :on-change="onDefectNumberChange"
            type="number"
            :is-focus-clear="true"
          ></text-box>
        </div>
        <div class="m-1">
          {{ defectData.package_unit }}
        </div>
      </div>
    </div>
    <div class="flex">
      <div class="flex-row mr-2">
        <button type="button" @click="defectPharmacyMedicineConfirm" class="w-full py-2.5 px-5 mr-2 my-2 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-full border border-gray-200 hover:bg-amber-300 hover:text-black focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">登録する</button>
      </div>
      <div class="flex-row">
        <button type="button" @click="closeEditPharmacyMedicineDefect" class="w-full py-2.5 px-5 mr-2 my-2 text-sm font-medium text-white focus:outline-none bg-red-700 rounded-full border border-gray-200 hover:bg-red-600 hover:text-white focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-red-600 dark:hover:text-white dark:hover:bg-red-700">キャンセル</button>
      </div>
    </div>
  </template>
</modal-dialog>
<modal-dialog
  :is-visible="isMedicineDetailDialog"
  width="90%"
  :close="closeMedicineDetailDialog"
>
  <template v-slot:header>
    採用品在庫履歴
  </template>
  <template v-slot:default>
    <medicine-history-detail-component
      :apis="apis"
      :search-key="detailYjCode"
    ></medicine-history-detail-component>
  </template>
</modal-dialog>

<modal-dialog
  :is-visible="isMedicineHistoryDialog"
  width="90%"
  :close="closeMedicineHistoryDialog"
>
  <template v-slot:header>
    採用品受発注履歴
  </template>
  <template v-slot:default>
    <medicine-history-list-component
      :apis="apis"
      :yj-code="historyMedicineYjCode"
      :history-medicine-name="historyMedicineName"
    ></medicine-history-list-component>
  </template>
</modal-dialog>

<modal-dialog
  :is-visible="isEditVitalWaitMedicineDialog"
  width="95%"
  :close="closeEditVitalWaitMedicine"
>
  <template v-slot:header>
    切替候補追加
  </template>
  <template v-slot:default>
    <pharmacy-medicine-edit-component
      :apis="apis"
      :pharmacy-wholesalers="pharmacyWholesalers"
      :same-code="sameCode"
      :identity-id="editVitalWaitMedicineIdentityId"
      :cancel="closeEditVitalWaitMedicine"
      :updateComplete="updateCompleteVitalWaitMedicine"
    ></pharmacy-medicine-edit-component>
  </template>
</modal-dialog>

<modal-dialog
  :is-visible="isLoading"
  width="40%"
  :isLoading="true"
>
  <template v-slot:header>
  </template>
  <template v-slot:default>
  <div class="mb-6">
    処理中です。
  </div>
  </template>
</modal-dialog>
</template>
